import React, {Component} from "react";
import {Link} from 'react-router-dom';

class LandingPage extends Component {
    render = () => {

        return (
            <div className="container-fluid sos-body-container px-0">
                <div className="row parentContent-wrapper w-100 mx-0"> {/* Landing Page */}
                    <div className="col-12 landingPage-wrapper">
                        <div className="row pt-3">
                            <div className="col-6 left-logo">
                                <a href="" target="_blank">
                                    <img src="/assets/images/Senstra_logo-2.png" alt="logo" className="img-fluid"/>
                                </a>
                            </div>
                            <div className="col-6 text-right right-awsIcon">
                                <img src="/assets/images/aws-icon.png" alt="aws-icon"/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center caption-outer">
                                <h1> Senstra </h1>
                                <p> A scalable, modular, secure, cloud-based IOT solution </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center videoBtn-outer">
                                <img src="/assets/images/video-icon.png" alt="video-icon"/><br/>
                                <a href="#/signin"><button className="getStarted-btn">Get Started !</button></a>

                                <h6 className="pt-5"> App Catalogue </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

export default LandingPage;


// WEBPACK FOOTER //
// ./app/routes/components/routes/homePage/homePage.js